/**
 * GA4 dataLayer katmani — Prestige (Maestrooo) temasi icin.
 *
 * Temanin kendi CustomEvent sistemine baglanir; fetch monkey-patch yapmaz.
 *
 * Prestige olay haritasi:
 *   variant:add    (form uzerinde, bubbles)  -> { items, cart }      -> add_to_cart
 *   cart:change    (documentElement)         -> { baseEvent, cart }  -> remove_from_cart
 *   variant:change (form uzerinde, bubbles)  -> { variant }          -> view_item
 *   dialog:after-show (cart-drawer)                                  -> view_cart
 *
 * Uretilen event'ler:
 *   view_item_list, select_item, add_to_cart, remove_from_cart,
 *   view_cart, begin_checkout, view_promotion, select_promotion
 *
 * view_item — sections/main-product.liquid icinden push edilir.
 * Checkout event'leri Shopify Custom Pixel tarafindan uretilir.
 */

window.dataLayer = window.dataLayer || [];

window.FahharKidsGTM = (function () {
  'use strict';

  var STORAGE_KEY = 'fahhar_kids_gtm_item_list';
  var LIST_TTL_MS = 1000 * 60 * 60 * 24 * 7; // 7 gun
  var MAX_LIST_ENTRIES = 300;

  /**
   * Merchant Center offer ID onki.
   *
   * Shopify Google & YouTube app feed'i su bicimde uretiyor:
   *   shopify_TR_<productId>_<variantId>   (Kids feed ulke kodu: TR)
   *
   * ⚠ CANLIYA ALMADAN ONCE DOGRULA: Merchant Center'da birkac urunun offer
   * ID'sine bak, onekin buradakiyle ayni oldugunu teyit et. Farkliysa hem
   * burayi hem 2 Liquid sablonunu (product-card, product-card-horizontal)
   * hem de Custom Pixel'i birlikte guncelle.
   */
  var MC_PREFIX = 'shopify_TR_';

  function merchantItemId(productId, variantId) {
    if (!productId || !variantId) return String(variantId || productId || '');
    return MC_PREFIX + productId + '_' + variantId;
  }

  /* ─── Yardimcilar ───────────────────────────────────────────────────── */

  /** Shopify fiyatlari kurus cinsinden gelir; GA4 ondalik bekler. */
  function money(cents) {
    var value = Number(cents);
    if (!isFinite(value)) return undefined;
    return Math.round(value) / 100;
  }

  function currencyCode() {
    return (
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'TRY'
    );
  }

  function parseCategories(productType) {
    if (!productType) return {};
    var parts = String(productType)
      .split('>')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var keys = ['item_category', 'item_category2', 'item_category3', 'item_category4'];
    var result = {};
    parts.slice(0, 4).forEach(function (part, i) { result[keys[i]] = part; });
    return result;
  }

  function numericId(value) {
    if (value === null || value === undefined || value === '') return '';
    var parts = String(value).split('/');
    return parts[parts.length - 1];
  }

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function writeStore(store) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (e) { /* kota dolu veya erisim yok */ }
  }

  /** Urunun hangi listeden geldigini sakla — tum huni boyunca tasinir. */
  function setItemListContext(productId, listId, listName) {
    if (!productId || !listId) return;
    var store = readStore();
    store[String(productId)] = {
      item_list_id: String(listId),
      item_list_name: listName ? String(listName) : '',
      t: Date.now()
    };

    var keys = Object.keys(store);
    if (keys.length > MAX_LIST_ENTRIES) {
      keys
        .sort(function (a, b) { return (store[a].t || 0) - (store[b].t || 0); })
        .slice(0, keys.length - MAX_LIST_ENTRIES)
        .forEach(function (k) { delete store[k]; });
    }

    writeStore(store);
  }

  function getItemListContext(productId) {
    if (!productId) return null;
    var entry = readStore()[String(productId)];
    if (!entry) return null;
    if (entry.t && Date.now() - entry.t > LIST_TTL_MS) return null;
    return { item_list_id: entry.item_list_id, item_list_name: entry.item_list_name };
  }

  /** GA4 spec: her ecommerce event'inden once ecommerce sifirlanir. */
  function pushEvent(eventData) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(eventData);
  }

  function clean(object) {
    var result = {};
    Object.keys(object).forEach(function (key) {
      var value = object[key];
      if (value !== undefined && value !== null && value !== '') result[key] = value;
    });
    return result;
  }

  /** Shopify sepet satirini GA4 item'ina cevirir. */
  function lineItemToGA4(line) {
    if (!line) return null;

    var productId = numericId(line.product_id);
    var variantId = numericId(line.variant_id || line.id);
    var context = getItemListContext(productId) || {};

    var item = clean({
      item_id: merchantItemId(productId, variantId),
      item_variant_id: variantId,
      item_product_id: productId,
      item_name: line.product_title || line.title,
      item_brand: line.vendor,
      item_variant: line.variant_title,
      item_sku: line.sku,
      price: money(line.price),
      quantity: Number(line.quantity) || 1,
      item_list_id: context.item_list_id,
      item_list_name: context.item_list_name
    });

    Object.assign(item, parseCategories(line.product_type));

    return item;
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart.js';
  }

  function fetchCart() {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); });
  }

  return {
    money: money,
    currencyCode: currencyCode,
    parseCategories: parseCategories,
    numericId: numericId,
    merchantItemId: merchantItemId,
    setItemListContext: setItemListContext,
    getItemListContext: getItemListContext,
    pushEvent: pushEvent,
    clean: clean,
    lineItemToGA4: lineItemToGA4,
    fetchCart: fetchCart
  };
})();

/* ═══════════════════════════════════════════════════════════════════════
   view_item_list + select_item
   [data-gtm-list-id] tasiyan her <product-list> izlenir.
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharKidsGTM;
  var initialized = new WeakSet();

  // Prestige urun kartlari <product-card> ozel elementi.
  var CARD_SELECTOR = 'product-card, .product-card, .horizontal-product-card';

  function cardData(card) {
    var holder = card.querySelector('[data-gtm-product]');
    if (!holder) return null;
    try {
      return JSON.parse(holder.textContent);
    } catch (e) {
      return null;
    }
  }

  function buildItem(card, listId, listName, index) {
    var data = cardData(card);
    if (!data || !data.item_id) return null;

    var item = G.clean({
      item_id: String(data.item_id),
      item_variant_id: data.item_variant_id,
      item_name: data.item_name,
      item_brand: data.item_brand,
      item_variant: data.item_variant,
      item_sku: data.item_sku,
      price: data.price,
      quantity: 1,
      index: index,
      item_list_id: String(listId),
      item_list_name: listName
    });

    Object.assign(item, G.parseCategories(data.item_type));

    // Baglam URUN id'siyle saklanir: kullanici PDP'de varyant degistirse de korunur.
    G.setItemListContext(data.item_product_id || data.item_id, listId, listName);

    return item;
  }

  function collectItems(container, listId, listName) {
    var startIndex = parseInt(container.getAttribute('data-gtm-start-index'), 10);
    if (!isFinite(startIndex)) startIndex = 0;

    var cards = container.querySelectorAll(CARD_SELECTOR);
    var items = [];

    Array.prototype.forEach.call(cards, function (card, i) {
      var item = buildItem(card, listId, listName, startIndex + i + 1);
      if (item) items.push(item);
    });

    return items;
  }

  var lastSignature = new WeakMap();

  function fireViewItemList(container) {
    var listId = container.getAttribute('data-gtm-list-id');
    var listName = container.getAttribute('data-gtm-list-name') || '';
    if (!listId) return;

    var items = collectItems(container, listId, listName);
    if (!items.length) return;

    // Ayni liste tekrar gonderilmesin; icerik degisirse imza degisir.
    var signature = items.map(function (item) { return item.item_id; }).join(',');
    if (lastSignature.get(container) === signature) return;
    lastSignature.set(container, signature);

    G.pushEvent({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: String(listId),
        item_list_name: listName,
        items: items
      }
    });
  }

  function observe(container) {
    if (initialized.has(container)) return;
    initialized.add(container);

    var pending = null;

    function scheduleAttempt() {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        fireViewItemList(container);
      }, 250);
    }

    function onVisible() {
      fireViewItemList(container);

      // Filtre yenileme, sonsuz kaydirma, anlik arama sonuclari.
      new MutationObserver(scheduleAttempt).observe(container, {
        childList: true,
        subtree: true
      });
    }

    if (!('IntersectionObserver' in window)) {
      onVisible();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        onVisible();
      });
    }, { threshold: 0.15 });

    observer.observe(container);
  }

  function scan() {
    var containers = document.querySelectorAll('[data-gtm-list-id]');
    Array.prototype.forEach.call(containers, observe);
  }

  function init() {
    scan();

    var mutationObserver = new MutationObserver(function (mutations) {
      var shouldScan = false;
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.hasAttribute && node.hasAttribute('data-gtm-list-id')) shouldScan = true;
          else if (node.querySelector && node.querySelector('[data-gtm-list-id]')) shouldScan = true;
        });
      });
      if (shouldScan) scan();
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* ─── select_item ───────────────────────────────────────────────────── */

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="/products/"]');
    if (!link) return;

    var card = link.closest(CARD_SELECTOR);
    if (!card) return;

    var container = card.closest('[data-gtm-list-id]');
    if (!container) return;

    var listId = container.getAttribute('data-gtm-list-id');
    var listName = container.getAttribute('data-gtm-list-name') || '';

    var cards = container.querySelectorAll(CARD_SELECTOR);
    var index = Array.prototype.indexOf.call(cards, card);
    var startIndex = parseInt(container.getAttribute('data-gtm-start-index'), 10);
    if (!isFinite(startIndex)) startIndex = 0;

    var item = buildItem(card, listId, listName, startIndex + index + 1);
    if (!item) return;

    G.pushEvent({
      event: 'select_item',
      ecommerce: {
        item_list_id: String(listId),
        item_list_name: listName,
        items: [item]
      }
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ═══════════════════════════════════════════════════════════════════════
   add_to_cart — Prestige'in native `variant:add` olayi
   detail.items eklenen satirlari dogrudan veriyor.
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharKidsGTM;

  document.addEventListener('variant:add', function (event) {
    var lines = (event.detail && event.detail.items) || [];
    if (!lines.length) return;

    var items = lines
      .map(function (line) { return G.lineItemToGA4(line); })
      .filter(Boolean);

    if (!items.length) return;

    var value = items.reduce(function (sum, item) {
      return sum + (item.price || 0) * (item.quantity || 1);
    }, 0);

    G.pushEvent({
      event: 'add_to_cart',
      ecommerce: {
        currency: G.currencyCode(),
        value: Math.round(value * 100) / 100,
        items: items
      }
    });
  }, true);
})();

/* ═══════════════════════════════════════════════════════════════════════
   remove_from_cart — `cart:change` uzerinden sepet farki
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharKidsGTM;
  var snapshot = null;

  /**
   * Satirlar VARYANT id'siyle eslesir. line.key kullanilmaz: farkli
   * kaynaklardaki key bicimi ayni olmayabiliyor ve eslesmeyince fark alma
   * yanlis remove_from_cart uretiyor.
   */
  function toMap(cart) {
    var map = {};

    ((cart && cart.items) || []).forEach(function (line) {
      var key = String(line.variant_id || line.id || '');
      if (!key) return;

      if (map[key]) {
        map[key] = Object.assign({}, map[key], {
          quantity: Number(map[key].quantity || 0) + Number(line.quantity || 0)
        });
      } else {
        map[key] = line;
      }
    });

    return map;
  }

  function diffAndFire(cart) {
    var next = toMap(cart);

    if (snapshot === null) {
      snapshot = next;
      return;
    }

    var removed = [];

    Object.keys(snapshot).forEach(function (key) {
      var before = snapshot[key];
      var after = next[key];
      var lostQty = after
        ? Number(before.quantity) - Number(after.quantity)
        : Number(before.quantity);

      if (lostQty > 0) {
        var item = G.lineItemToGA4(before);
        if (item) {
          item.quantity = lostQty;
          removed.push(item);
        }
      }
    });

    snapshot = next;

    if (!removed.length) return;

    var value = removed.reduce(function (sum, item) {
      return sum + (item.price || 0) * (item.quantity || 1);
    }, 0);

    G.pushEvent({
      event: 'remove_from_cart',
      ecommerce: {
        currency: G.currencyCode(),
        value: Math.round(value * 100) / 100,
        items: removed
      }
    });
  }

  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    diffAndFire(cart);
  }, true);

  G.fetchCart()
    .then(function (cart) { snapshot = toMap(cart); })
    .catch(function () { snapshot = {}; });
})();

/* ═══════════════════════════════════════════════════════════════════════
   view_cart — sepet cekmecesi acilisi + /cart sayfasi
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharKidsGTM;
  var lastFiredAt = 0;

  function cartItems(cart) {
    return ((cart && cart.items) || [])
      .map(function (line) { return G.lineItemToGA4(line); })
      .filter(Boolean);
  }

  function fireViewCart(cart) {
    if (!cart) return;

    var now = Date.now();
    if (now - lastFiredAt < 2000) return;
    lastFiredAt = now;

    var items = cartItems(cart);
    if (!items.length) return;

    G.pushEvent({
      event: 'view_cart',
      ecommerce: {
        currency: G.currencyCode(),
        value: G.money(cart.total_price),
        items: items
      }
    });
  }

  function loadAndFire() {
    G.fetchCart().then(fireViewCart).catch(function () {});
  }

  // Prestige sepet cekmecesi bir dialog; acildiginda haber veriyor.
  document.addEventListener('dialog:after-show', function (event) {
    var target = event.target;
    if (!target) return;

    var isCartDrawer =
      target.id === 'cart-drawer' ||
      (target.closest && target.closest('cart-drawer')) ||
      (target.tagName && target.tagName.toLowerCase() === 'cart-drawer');

    if (!isCartDrawer) return;
    loadAndFire();
  }, true);

  // /cart sayfasi
  if (/\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search)) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadAndFire);
    } else {
      loadAndFire();
    }
  }

  window.FahharKidsGTM.cartItems = cartItems;
})();

/* ═══════════════════════════════════════════════════════════════════════
   begin_checkout
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharKidsGTM;
  var lastFiredAt = 0;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[name="checkout"], [data-gtm-begin-checkout]');
    if (!button) return;

    var now = Date.now();
    if (now - lastFiredAt < 3000) return;
    lastFiredAt = now;

    G.fetchCart()
      .then(function (cart) {
        var items = G.cartItems(cart);
        if (!items.length) return;

        G.pushEvent({
          event: 'begin_checkout',
          ecommerce: {
            currency: G.currencyCode(),
            value: G.money(cart.total_price),
            items: items
          }
        });
      })
      .catch(function () {});
  }, true);
})();

/* ═══════════════════════════════════════════════════════════════════════
   view_promotion / select_promotion
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var G = window.FahharKidsGTM;
  var seen = new WeakSet();

  function promoPayload(element) {
    return G.clean({
      promotion_id: element.getAttribute('data-gtm-promo-id'),
      promotion_name: element.getAttribute('data-gtm-promo-name'),
      creative_slot: element.getAttribute('data-gtm-creative-slot'),
      creative_name: element.getAttribute('data-gtm-creative-name')
    });
  }

  function fireViewPromotion(element) {
    if (seen.has(element)) return;
    seen.add(element);

    var payload = promoPayload(element);
    if (!payload.promotion_id) return;

    G.pushEvent({ event: 'view_promotion', ecommerce: payload });
  }

  function observe(element) {
    if (!('IntersectionObserver' in window)) {
      fireViewPromotion(element);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        // Slider'da gizli slide'lar DOM'da durur; gorunurlugu dogrula.
        if (entry.target.offsetParent === null) return;
        observer.unobserve(entry.target);
        fireViewPromotion(entry.target);
      });
    }, { threshold: 0.5 });

    observer.observe(element);
  }

  function scan() {
    var elements = document.querySelectorAll('[data-gtm-promo-id]');
    Array.prototype.forEach.call(elements, function (element) {
      if (seen.has(element)) return;
      observe(element);
    });
  }

  function init() {
    scan();
    new MutationObserver(scan).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  document.addEventListener('click', function (event) {
    var element = event.target.closest('[data-gtm-promo-id]');
    if (!element) return;

    var payload = promoPayload(element);
    if (!payload.promotion_id) return;

    G.pushEvent({ event: 'select_promotion', ecommerce: payload });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
